import type { Action, State } from './types'

export const initialState: State = {
  expandedRow: {
    id: undefined
  },

  searchParams: {
    query: '',
    schedule: undefined,
    locations: [],
    coverageCategories: [],
    flags: []
  },

  pagination: {
    pageSize: 10,
    currentPage: 0
  },

  sort: {
    field: undefined,
    order: undefined
  },

  schedulePreview: {
    isOpen: false
  }
}

export function reducer(state: State, action: Action): State {
  switch (action.type) {
    case 'set-query': {
      return {
        ...state,
        searchParams: {
          ...state.searchParams,
          query: action.payload
        }
      }
    }

    case 'set-filters': {
      return {
        ...state,
        searchParams: {
          ...state.searchParams,
          ...action.payload
        },
        pagination: {
          ...state.pagination,
          currentPage: 0
        }
      }
    }

    case 'set-expanded-row-id': {
      return {
        ...state,
        expandedRow: {
          ...state.expandedRow,
          id: action.payload
        }
      }
    }

    case 'clear-expanded-row-id': {
      return {
        ...state,
        expandedRow: {
          ...state.expandedRow,
          id: undefined
        }
      }
    }

    case 'set-sort': {
      return {
        ...state,
        sort: action.payload,
        pagination: {
          ...state.pagination,
          currentPage: 0
        }
      }
    }

    case 'set-pagination': {
      return {
        ...state,
        pagination: action.payload
      }
    }

    case 'open-schedule-preview': {
      return {
        ...state,
        schedulePreview: {
          ...state.schedulePreview,
          isOpen: true
        }
      }
    }

    case 'close-schedule-preview': {
      return {
        ...state,
        schedulePreview: {
          ...state.schedulePreview,
          isOpen: false
        }
      }
    }

    case 'toggle-schedule-preview': {
      return {
        ...state,
        schedulePreview: {
          ...state.schedulePreview,
          isOpen: !state.schedulePreview.isOpen
        }
      }
    }

    default: {
      return state
    }
  }
}
